import type { ComponentPropsWithoutRef } from "react";

import { cn } from "~/utils";

export function LoadingIndicator({
  className,
  ...props
}: ComponentPropsWithoutRef<"span">) {
  return (
    <span
      aria-hidden="true"
      className={cn(
        "inline-block size-4 shrink-0 animate-spin rounded-full border-2 border-current border-r-transparent motion-reduce:animate-none",
        className,
      )}
      {...props}
    />
  );
}
